<!--
  Une ligne de réglage colorée, comme la ligne « Premium » des réglages d'un
  téléphone : l'étoile, le nom, une ligne d'avantages, l'essai et le prix en
  bref, un chevron. Le détail et le choix de la formule sont dans le paywall.

  Doré = signal premium, jamais l'orange des avertissements ; vert = ce qui est
  offert, comme les coches du paywall. Toute la carte est un seul bouton.
-->
@if (premiumService.premiumEnabled()) {
<button
  type="button"
  class="flex w-full items-center gap-3 rounded-card border border-vw-premium-line bg-gradient-to-br from-vw-premium-bg to-vw-premium-bg-deep px-4 py-3 text-left"
  (click)="onClick()"
>
  <span
    class="flex h-10 w-10 shrink-0 items-center justify-center rounded-pill bg-gradient-to-br from-vw-premium-accent to-vw-premium-line text-vw-on-color"
    aria-hidden="true"
  >
    <svg viewBox="0 0 24 24" class="h-5 w-5" fill="currentColor">
      <path d="M12 2l2.9 6.3 6.9.8-5.1 4.7 1.4 6.8L12 17.3 5.9 20.6l1.4-6.8L2.2 9.1l6.9-.8L12 2z" />
    </svg>
  </span>

  <span class="flex min-w-0 grow flex-col">
    <span class="text-body font-semibold text-vw-ink">{{ 'premium.profile.title' | translate }}</span>
    <span class="text-body-s text-vw-muted">{{ 'premium.profile.subtitle' | translate }}</span>
    <!-- L'essai seulement s'il peut être lancé ici ; le prix, celui du fournisseur. -->
    @if (trial || priceLine) {
      <span class="mt-1.5 flex flex-wrap items-center gap-x-2 gap-y-1">
        @if (trial; as offer) {
          <span class="rounded-pill bg-vw-surface-tint px-2 py-0.5 text-caption text-vw-primary-ink">
            {{ 'premium.paywall.trial-chip' | translate: { days: offer.days } }}
          </span>
        }
        @if (priceLine; as line) {
          <span class="text-caption text-vw-premium-ink">{{ line.key | translate: { price: line.price } }}</span>
        }
      </span>
    }
  </span>

  <vw-chevron-right-icon class="block h-6 w-6 shrink-0 text-vw-premium-ink" aria-hidden="true" />
</button>
}
